import { useMutation } from "@tanstack/react-query";
import { cnlResvInfApi } from "components/api/mypage";
import BookCancelView from "components/view/mypage/book/inf/cancelInf";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { successControl } from "util/commAction";

export default function CancelInfPage() {
  const { rmPdNo } = useParams();
  const [cnlResvInf, setCnlResvInf] = useState();

  //예약 취소 조회
  const cnlInfMutation = useMutation({
    mutationFn: cnlResvInfApi,
    onSuccess(res) {
      if (res) {
        const inf = {
          ...res.data.resvInf,
          cnlFeeAmt: res.data.cnlFeeAmt,
          refAmt: res.data.refAmt,
        };
        successControl({
          status: res.status,
          success: () => {
            setCnlResvInf(inf);
          },
        });
      }
    },
  });

  useEffect(() => {
    if (!!rmPdNo) {
      cnlInfMutation.mutate(rmPdNo);
    }
  }, [rmPdNo]);

  return (
    <>
      <BookCancelView cnlResvInf={cnlResvInf} />
    </>
  );
}
